import i18n from '@/i18n';

export default [
  {
    path: '/billing',
    name: 'billing',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'billing',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('billing')
    },
    // route level code-splitting
    component: () =>
      import('../../views/billing/Index'),
    children: [
      {
        path: 'new',
        name: 'billing-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'billing',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('billing'),
        },
        component: () => import('../../views/billing/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'billing-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'billing',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('billing'),
        },
        component: () => import('../../views/billing/Edit.vue'),
      },
    ],
  },
];
